import { Component } from '@angular/core';

@Component({
  selector: 'app-rheology-vertical-header',
  standalone: false,
  templateUrl: './rheology-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class RheologyVerticalHeaderComponent  {

 
}
